var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef } from "react";
import FormControlWrapper from "./FormControlWrapper";
import Input from "./Input";
const FormControl = (_a) => {
    var { isInvalid = false, isRequired = false, error, hint, label, placeholder, labelProps, type, step, multiline } = _a, rest = __rest(_a, ["isInvalid", "isRequired", "error", "hint", "label", "placeholder", "labelProps", "type", "step", "multiline"]);
    const inputRef = useRef(null);
    useEffect(() => {
        if (type !== "number") {
            return;
        }
        const input = inputRef.current;
        if (!input) {
            return;
        }
        input.setNativeProps({
            type,
            step,
        });
    }, [type, step]);
    const resolvedType = type === "number" || type === "email" ? "text" : type;
    const keyboardType = type === "number"
        ? "decimal-pad"
        : type === "email"
            ? "email-address"
            : "default";
    return (_jsx(FormControlWrapper, Object.assign({ isInvalid: isInvalid, isRequired: isRequired, error: error, hint: hint, label: label, labelProps: labelProps }, { children: _jsx(Input, Object.assign({ ref: inputRef, type: resolvedType, keyboardType: keyboardType, placeholder: placeholder, isInvalid: isInvalid, isRequired: isRequired, minHeight: multiline ? 20 : undefined, multiline: multiline }, rest)) })));
};
export default FormControl;
